export interface PageInterface {
  page: string
}

export const pages = {
  pageConsent: { page: 'consent' },
  pageError: { page: 'error' },
  pageSuccess: { page: 'success' },
}
